import { render, staticRenderFns } from "./referral-info-list-cards.vue?vue&type=template&id=e85ac920&scoped=true&"
import script from "./referral-info-list-cards.vue?vue&type=script&lang=js&"
export * from "./referral-info-list-cards.vue?vue&type=script&lang=js&"
import style0 from "./referral-info-list-cards.vue?vue&type=style&index=0&id=e85ac920&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85ac920",
  null
  
)

export default component.exports